module.exports = "//d274d294w9cx2v.cloudfront.net/9acc14f732b4067a17d07e44e19680c7d030961d/images/photo-single.png";